import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { createQueryClient } from './lib/query-client'
import { NotFound } from './components/not-found'

export const queryClient = createQueryClient()

export const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultNotFoundComponent: NotFound,
    context: {},
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
